import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

// Import component
import App from './App.tsx';

// Import constants
import { SENTRY_DSN } from './constants/env';

// Import Sentry for error tracking
import * as Sentry from '@sentry/react';

// Import Vercel Analytics and Speed Insights
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

Sentry.init({
  dsn: SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  tracePropagationTargets: ["https://whenwemeet.xyz", /^\/api\//],
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <Analytics />
    <SpeedInsights />
  </StrictMode>,
);
